module.exports = __webpack_public_path__ + "img/t2-c2.9e5cb0f5.png";